(function () {
  if (window.__firmhouseCartGuardInitialized) {
    return;
  }

  window.__firmhouseCartGuardInitialized = true;

  var isUpdating = false;
  var cartSnapshot = null;
  var cartSnapshotPromise = null;
  var cartSnapshotRefreshTimer = 0;

  function getRootCartUrl(pathname) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root + pathname.replace(/^\//, "");
  }

  function fetchCart() {
    return fetch(getRootCartUrl("/cart.js"), {
      headers: {
        Accept: "application/json"
      },
      credentials: "same-origin"
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to load cart.");
      }

      return response.json().then(function (cart) {
        cartSnapshot = cart;
        return cart;
      });
    });
  }

  function changeLineQuantity(line, quantity) {
    return fetch(getRootCartUrl("/cart/change.js"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to update cart.");
      }

      return response.json().then(function (cart) {
        cartSnapshot = cart;
        return cart;
      });
    });
  }

  function loadCartSnapshot() {
    if (cartSnapshotPromise) {
      return cartSnapshotPromise;
    }

    cartSnapshotPromise = fetchCart()
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        cartSnapshotPromise = null;
        return cart;
      });

    return cartSnapshotPromise;
  }

  function scheduleCartSnapshotRefresh() {
    window.clearTimeout(cartSnapshotRefreshTimer);
    cartSnapshotRefreshTimer = window.setTimeout(loadCartSnapshot, 500);
  }

  function getProperties(item) {
    return item && item.properties ? item.properties : {};
  }

  function isVehicleBundleLine(item) {
    var properties = getProperties(item);
    return properties._firmhouse_mode === "subscription";
  }

  function isDepositBundleLine(item) {
    var properties = getProperties(item);
    return String(properties.Type || "").indexOf("Borg") !== -1;
  }

  function isSubscriptionBundleLine(item) {
    var properties = getProperties(item);
    return Boolean(item && item.selling_plan_allocation && properties._linked_vehicle_variant_id);
  }

  function isStandaloneBatteryBundleLine(item) {
    var properties = getProperties(item);
    return Boolean(properties._firmhouse_bundle_type === "battery_only" && properties._firmhouse_bundle_id);
  }

  function isBundleLine(item) {
    return isVehicleBundleLine(item) || isDepositBundleLine(item) || isSubscriptionBundleLine(item) || isStandaloneBatteryBundleLine(item);
  }

  function stringValue(value) {
    return value === undefined || value === null ? "" : String(value);
  }

  function findVehicleBundle(cart, item, fallbackLine) {
    var items = cart.items || [];
    var itemProps = getProperties(item);

    if (isVehicleBundleLine(item)) {
      return {
        item: item,
        line: fallbackLine
      };
    }

    var linkedVehicleId = stringValue(itemProps._linked_vehicle_variant_id);
    var linkedDepositId = stringValue(itemProps._linked_deposit_variant_id);

    for (var index = 0; index < items.length; index += 1) {
      var candidate = items[index];
      var candidateProps = getProperties(candidate);

      if (!isVehicleBundleLine(candidate)) {
        continue;
      }

      if (stringValue(candidate.id) !== linkedVehicleId) {
        continue;
      }

      if (isSubscriptionBundleLine(item) && stringValue(candidateProps._linked_subscription_variant_id) !== stringValue(item.id)) {
        continue;
      }

      if (linkedDepositId && stringValue(candidateProps._linked_deposit_variant_id) !== linkedDepositId) {
        continue;
      }

      return {
        item: candidate,
        line: index + 1
      };
    }

    return null;
  }

  function buildBundleForLine(cart, line) {
    var items = cart.items || [];
    var item = items[line - 1];

    if (!item || !isBundleLine(item)) {
      return null;
    }

    if (isStandaloneBatteryBundleLine(item)) {
      var standaloneBundleId = stringValue(getProperties(item)._firmhouse_bundle_id);
      var standaloneLines = [];
      var standaloneQuantity = Number(item.quantity || 0);

      for (var standaloneIndex = 0; standaloneIndex < items.length; standaloneIndex += 1) {
        var standaloneCandidate = items[standaloneIndex];
        var standaloneProps = getProperties(standaloneCandidate);

        if (stringValue(standaloneProps._firmhouse_bundle_id) !== standaloneBundleId) {
          continue;
        }

        standaloneLines.push(standaloneIndex + 1);

        if (standaloneProps.Type === "Batterij abonnement") {
          standaloneQuantity = Number(standaloneCandidate.quantity || standaloneQuantity || 0);
        }
      }

      standaloneLines = standaloneLines.filter(function (lineNumber, indexValue, array) {
        return array.indexOf(lineNumber) === indexValue;
      });

      return {
        vehicleLine: 0,
        quantity: standaloneQuantity,
        lines: standaloneLines
      };
    }

    var vehicleBundle = findVehicleBundle(cart, item, line);

    if (!vehicleBundle) {
      return null;
    }

    var vehicleItem = vehicleBundle.item;
    var vehicleProps = getProperties(vehicleItem);
    var vehicleId = stringValue(vehicleItem.id);
    var expectedSubscriptionId = stringValue(vehicleProps._linked_subscription_variant_id);
    var expectedDepositId = stringValue(vehicleProps._linked_deposit_variant_id);
    var bundleLines = [vehicleBundle.line];

    for (var index = 0; index < items.length; index += 1) {
      var candidate = items[index];
      var candidateProps = getProperties(candidate);
      var candidateLine = index + 1;

      if (
        expectedSubscriptionId &&
        stringValue(candidate.id) === expectedSubscriptionId &&
        stringValue(candidateProps._linked_vehicle_variant_id) === vehicleId
      ) {
        bundleLines.push(candidateLine);
      }

      if (
        expectedDepositId &&
        stringValue(candidate.id) === expectedDepositId &&
        stringValue(candidateProps._linked_vehicle_variant_id) === vehicleId
      ) {
        bundleLines.push(candidateLine);
      }
    }

    bundleLines = bundleLines.filter(function (lineNumber, indexValue, array) {
      return array.indexOf(lineNumber) === indexValue;
    });

    return {
      vehicleLine: vehicleBundle.line,
      quantity: Number(vehicleItem.quantity || 0),
      lines: bundleLines
    };
  }

  function reloadCartView() {
    window.location.reload();
  }

  function updateBundleQuantity(bundle, nextQuantity) {
    if (!bundle || !bundle.lines || !bundle.lines.length) {
      return Promise.resolve();
    }

    var sortedLines = bundle.lines.slice().sort(function (left, right) {
      return right - left;
    });

    return sortedLines.reduce(function (promise, lineNumber) {
      return promise.then(function () {
        return changeLineQuantity(lineNumber, nextQuantity);
      });
    }, Promise.resolve());
  }

  function getLineFromControl(control) {
    var lineNode = control.closest("[xo-line], [data-cart-line], [data-line]");

    if (!lineNode) {
      return 0;
    }

    return Number(
      lineNode.getAttribute("xo-line") ||
        lineNode.getAttribute("data-cart-line") ||
        lineNode.getAttribute("data-line") ||
        0
    );
  }

  function updateSingleLineQuantity(cart, line, control) {
    var item = cart.items && cart.items[line - 1];

    if (!item) {
      return Promise.resolve();
    }

    if (control.matches("xo-cart-remove")) {
      return changeLineQuantity(line, 0);
    }

    if (control.matches("xo-cart-quantity-plus")) {
      return changeLineQuantity(line, Number(item.quantity || 0) + 1);
    }

    if (control.matches("xo-cart-quantity-minus")) {
      return changeLineQuantity(line, Math.max(0, Number(item.quantity || 0) - 1));
    }

    return Promise.resolve();
  }

  function getCachedBundleForLine(line) {
    if (!cartSnapshot) {
      return null;
    }

    return buildBundleForLine(cartSnapshot, line);
  }

  function interceptBundleControl(event) {
    if (!event.target || typeof event.target.closest !== "function") {
      return;
    }

    var control = event.target.closest("xo-cart-remove, xo-cart-quantity-minus, xo-cart-quantity-plus");

    if (!control) {
      return;
    }

    var line = getLineFromControl(control);

    if (!line || isUpdating) {
      if (isUpdating) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }

    var cachedBundle = getCachedBundleForLine(line);

    if (!cachedBundle) {
      scheduleCartSnapshotRefresh();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    isUpdating = true;

    fetchCart()
      .then(function (cart) {
        var bundle = buildBundleForLine(cart, line);

        if (!bundle) {
          return updateSingleLineQuantity(cart, line, control);
        }

        if (control.matches("xo-cart-remove")) {
          return updateBundleQuantity(bundle, 0);
        }

        if (control.matches("xo-cart-quantity-plus")) {
          return updateBundleQuantity(bundle, bundle.quantity + 1);
        }

        if (control.matches("xo-cart-quantity-minus")) {
          return updateBundleQuantity(bundle, Math.max(0, bundle.quantity - 1));
        }

        return null;
      })
      .then(function (result) {
        if (result) {
          reloadCartView();
        }
      })
      .catch(function (error) {
        isUpdating = false;
        window.console.error("[Firmhouse Cart Guard]", error);
      });
  }

  document.addEventListener("click", interceptBundleControl, true);
  loadCartSnapshot();
})();
